<ion-accordion-group class="BudgetPanel" multiple="true">
  @for (subBudget of budgets; track subBudget) {
    <ion-accordion [value]="subBudget.abbr + '-panel'">
      <ion-item slot="header" color="primary">
        <ion-label>
          <h3>{{ subBudget.title }}</h3>
          <p>{{ roi.calculationValues[subBudget.name] | currency }}</p>
          @if (subBudget.abbr === 'rep') {
            <div
              class="BudgetPanel__RightSide"
              (click)="$event.stopPropagation()"
            >
              <ion-checkbox
                (ionChange)="toggleRepair()"
                [checked]="includeRepairInLoan"
              ></ion-checkbox>
              <ion-label>&nbsp;&nbsp;Include in Loan</ion-label>
            </div>
          }
        </ion-label>
      </ion-item>
      <div class="ion-padding" slot="content">
        @switch (subBudget.abbr) {
          @case ('acq') {
            <app-acquisition-costs></app-acquisition-costs>
          }
          @case ('cry') {
            <app-carrying-costs></app-carrying-costs>
          }
          @case ('rep') {
            <app-repair-costs></app-repair-costs>
          }
          @case ('sel') {
            <app-selling-costs></app-selling-costs>
          }
          @case ('oth') {
            <app-other-costs></app-other-costs>
          }
        }
      </div>
    </ion-accordion>
  }
</ion-accordion-group>
